import React, { createContext, useState, useContext, useEffect } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

// Criar o contexto
const NavigationContext = createContext();

// Criar o componente provedor
export const NavigationProvider = ({ children, initialTab = 'appointments' }) => {
  const [activeTab, setActiveTab] = useState(initialTab);
  const navigate = useNavigate();
  const { salonId } = useParams();
  const location = useLocation();
  
  // Verificar se já estamos na rota de administração e extrair a aba atual
  useEffect(() => {
    const pathParts = location.pathname.split('/');
    if (pathParts.length >= 4 && pathParts[1] === 'admin') {
      const currentTab = pathParts[3] || 'appointments';
      if (currentTab !== activeTab) {
        setActiveTab(currentTab);
      }
    }
  }, [location.pathname, activeTab]);
  
  // Função para mudar a aba e também atualizar a URL
  const changeTab = (tabId) => {
    if (!salonId) {
      console.error('Não foi possível determinar o ID do salão para navegação');
      return;
    }
    
    setActiveTab(tabId);
    navigate(`/admin/${salonId}/${tabId}`);
  };
  
  // Valores a serem fornecidos pelo contexto
  const value = {
    activeTab,
    setActiveTab: changeTab
  };
  
  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
};

// Hook personalizado para usar o contexto
export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigation deve ser usado dentro de um NavigationProvider');
  }
  return context;
};
